import { deescapeJsonString } from "../SelfRating/transformFt";
import { inputResult } from "../Submit/SaveAnswer";


export function transformFtToResult(input:JQuery, results:inputResult, points:number, possible:number){
    
    input.prop('disabled', true);
    input.html(results.answer);

    const add = 'ft-' + (results.right * 100).toString();
    input.addClass(add);
    input.css('height', '100%');
    input.css('white-space', 'pre-wrap');


    const parent = input.parent();

    let html = displaySolution(results.correct)
    html += displayPoints(points, possible);

    parent.after(html)

}

export function displaySolution(solution:string|number){
    const html = '<div class="form-group"><div class="h-6 mt-2 self-head">Musterlösung</div>' +
    '<div disabled class="ft_right_antwort form-control my-2" id="ft-" style="height: 100%;">' + solution + '</div>' + 
    '</div></div>';
    return html;
}

function displayPoints(points:number, possible:number){
    const html = '<div class="self-feedback-result">Punkte für diese Eingabe: <b>' + points + '</b> von <b>' + possible + '</b></div>';
    return html;
}